import {Card} from '@sanity/ui'
import {styled} from 'styled-components'

export const Root = styled(Card)`
  position: relative;
  outline: none;
`

Root.displayName = 'PaneContent__root'
